import { API_NAME } from '../const';
import API from '@aws-amplify/api'
import { checkCurrentAuthenticatedUser } from 'utils/currentAuthenticatedUserChecker'

interface LockApplyResponce {
  numberOfRecordsUpdated: number
}

interface UnlockApplyResponce {
  numberOfRecordsUpdated: number
}

export async function lockApply(applyId: string): Promise<LockApplyResponce> {
  await checkCurrentAuthenticatedUser()
  const result = await API.put(API_NAME, `/v2/applies/${applyId}/lock`, {})
  return result.data
}

export async function unlockApply(applyId: string): Promise<UnlockApplyResponce> {
  await checkCurrentAuthenticatedUser()
  const result = await API.del(API_NAME, `/v2/applies/${applyId}/lock`, {})
  return result.data
}
